import styled from 'react-emotion'

export const MovieStyled = styled('div')({
  fontSize: '1.2rem',
  lineHeight: '1.4',
  color:  '#666',
  maxWidth: '90rem',
  width: '100%',
  margin: '0 auto'
})



// WEBPACK FOOTER //
// ./src/app.styles.js